import { isTitansAppOrWebview, isWeixinMiniProgramOrWeixinWebview, getPlatformType, PlatformType, getSystemType, SystemType } from '@nibfe/mkt-env-api';
const isWeb = true;
const isMRN = false;
import { getRiskParams } from '@nibfe/mkt-risk-api';
import { getLocation } from '@nibfe/mkt-lbs-api';
import { getCityInfo, getSelectedCityInfo } from '@max/meituan-uni-city';
import { reportJSInfo } from '@max/meituan-uni-report';
import { getUserInfo } from '@nibfe/mkt-user-api';
import { Source, Platform, LOCATION_SCENE_TOKEN } from '../constants';
import { getSystemInfoSync } from '@max/meituan-uni-system';
function parseQuery(queryString) {
    return queryString.substring(1).split('&').reduce((result, pair) => {
        const [key, value] = pair.split('=');
        result[decodeURIComponent(key)] = decodeURIComponent(value || '');
        return result;
    }, {});
}
export function allQueryInWeb() {
    if (typeof URLSearchParams !== 'undefined') {
        const searchParams = new URLSearchParams(window.location.search);
        return Object.fromEntries(searchParams.entries());
    }
    // Fallback for older browsers
    return parseQuery(window.location.search);
}
export function isHarmonyOs() {
    try {
        return getSystemType() === SystemType.harmony;
    }
    catch (e) {
        return false;
    }
}
export function isIOS() {
    try {
        return getSystemInfoSync().platform === 'ios';
    }
    catch (e) {
        return false;
    }
}
export function isAndroid() {
    try {
        return getSystemInfoSync().platform === 'android';
    }
    catch (e) {
        return false;
    }
}
export async function getRiskRequest() {
    // @ts-expect-error Not Matched types
    let riskParams = {};
    try {
        riskParams = await getRiskParams(/** 风险标识-酒店 */ 2);
    }
    catch (e) {
        reportJSInfo({
            secCategory: 'jsError',
            level: 'info',
            e,
            tags: {
                name: '获取风控参数异常'
            }
        }).catch();
    }
    const locationResult = {
        latitude: '0.0',
        longitude: '0.0',
        cityId: 1,
        locateCityId: 1
    };
    const appMap = {
        'hotel': 231,
        'mt': 328,
        'dp': 304
    };
    try {
        const [location, cityInfo, selectedCityInfo] = await Promise.all([getLocation({
                sceneToken: LOCATION_SCENE_TOKEN
            }), getCityInfo(), getSelectedCityInfo()]);
        locationResult.latitude = `${location.lat || '0.0'}` || '0.0';
        locationResult.longitude = `${location.lng || '0.0'}` || '0.0';
        locationResult.cityId = selectedCityInfo.id || 1;
        locationResult.locateCityId = cityInfo.id || cityInfo.cityId || 1;
    }
    catch (e) {
        reportJSInfo({
            secCategory: 'jsError',
            level: 'info',
            e,
            tags: {
                name: '获取定位异常'
            }
        });
    }
    let wxExtraParams = {
        expoId: '',
        app: appMap['hotel']
    };
    try {
        if (isWeixinMiniProgramOrWeixinWebview()) {
            const { openIdCipher = '', programName = 'hotel' } = allQueryInWeb();
            wxExtraParams.expoId = openIdCipher;
            if (programName) {
                // @ts-expect-error
                wxExtraParams.app = appMap[programName || 'hotel'];
            }
        }
    }
    catch (e) {
        reportJSInfo({
            secCategory: 'jsError',
            level: 'info',
            e,
            tags: {
                name: '获取微信expoId异常'
            }
        });
    }
    // 根据不同操作系统设置 utmMedium 参数
    const isIOSPlatform = isIOS();
    const isAndroidPlatform = isAndroid();
    const isInHarmony = isHarmonyOs();
    const utmMedium = isIOSPlatform ? 'iphone' : isAndroidPlatform ? 'android' : isInHarmony ? 'HarmonyOS' : '';
    const platformExtraParams = utmMedium ? {
        utmMedium
    } : {};
    return {
        ...riskParams,
        fingerprint: isTitansAppOrWebview() ? riskParams.fingerprint : riskParams.h5Fingerprint,
        h5_fingerprint: riskParams.h5Fingerprint,
        operateSource: isMRN ? 'App' : isWeb ? 'H5' : '',
        ...locationResult,
        ...(isWeixinMiniProgramOrWeixinWebview() ? wxExtraParams : {}),
        ...platformExtraParams
    };
}
export const DianpingPlatform = [PlatformType.dpApp, PlatformType.dpAppWebView, PlatformType.dpMinaWebview];
export const isDpPlatform = () => {
    const platformType = getPlatformType();
    return DianpingPlatform.includes(platformType);
};
export const getPlatform = () => {
    try {
        const isDp = isDpPlatform();
        return isDp ? Platform.DIANPING : Platform.MEITUAN;
    }
    catch (error) {
        return Platform.MEITUAN;
    }
};
export const getSource = () => {
    try {
        const platformType = getPlatformType();
        if (platformType === PlatformType.mtHotelMinaWebview) {
            return Source.WECHAT_HOTEL_MINI;
        }
        else if (platformType === PlatformType.mtMinaWebview) {
            return Source.WECHAT_MEITUAN_MINI;
        }
        else if (platformType === PlatformType.dpApp || platformType === PlatformType.dpAppWebView) {
            return Source.DIANPING_APP;
        }
        else if (platformType === PlatformType.dpMinaWebview) {
            return Source.WECHAT_DIANPING_MINI;
        }
        else {
            return Source.MEITUAN_APP;
        }
    }
    catch (error) {
        return Source.MEITUAN_APP;
    }
};
// 构建公共参数
export const buildCommonParams = async (commonParams) => {
    let userInfo = {};
    try {
        userInfo = await getUserInfo();
    }
    catch (error) {
        reportJSInfo({
            level: 'info',
            content: '手动获取getUserInfo失败',
            secCategory: 'jsError'
        }).catch();
    }
    if ((!commonParams?.token || !commonParams?.userId) && (!userInfo?.userId || !userInfo?.token)) {
        throw new Error('请求活动信息-用户信息异常');
    }
    if (isWeb && window.H5guard) {
        window.H5guard.init({});
    }
    const riskRequest = await getRiskRequest();
    const isDp = isDpPlatform();
    if (isWeixinMiniProgramOrWeixinWebview()) {
        // 删除多余字段防止请求体过长
        riskRequest.appletsFingerprint = riskRequest.fingerprint;
        riskRequest.fingerprint && delete riskRequest.fingerprint;
        riskRequest.h5Fingerprint && delete riskRequest.h5Fingerprint;
        riskRequest.h5_fingerprint && delete riskRequest.h5_fingerprint;
    }
    if (isDpPlatform()) {
        riskRequest.dpid = commonParams.uuid || riskRequest.uuid;
    }
    return {
        token: commonParams.token || userInfo.token,
        userId: String(commonParams.userId || userInfo.userId),
        // NOTE: 点评测试环境的userId存在超出最大整数情况
        // userId: Number(commonParams.userId || userInfo.userId), // NOTE: 点评测试环境的userId存在超出最大整数情况
        uuid: commonParams.uuid || riskRequest.uuid,
        platform: getPlatform(),
        source: getSource(),
        riskRequest,
        latitude: riskRequest.latitude,
        longitude: riskRequest.longitude,
        cityId: riskRequest.cityId,
        locateCityId: riskRequest.locateCityId,
        version: commonParams.appVersion || riskRequest.version,
        utm_campaign: isDp ? 'Adianping-novaBdianping-novaD0H0' : 'Meituan' // 决定筛选POI的城市体系
    };
};
/**
 * 判断是否为美团平台
 * @returns {boolean} 是否为美团平台
 */
export const IS_MT = [PlatformType.mtApp, PlatformType.mtAppWebView, PlatformType.mtMinaWebview, PlatformType.mtHotelMinaWebview].includes(getPlatformType());
/**
 * 校验URL是否符合平台要求
 * @param url 需要校验的URL
 * @param platform 平台类型，如'mrn'或'wx'
 * @returns 是否符合要求
 */
export const isValidUrl = (url, source) => {
    if (!url || typeof url !== 'string') {
        return false;
    }
    // 去除可能的空白字符
    const trimmedUrl = url.trim();
    // 根据平台进行校验
    switch (source) {
        case Source.MEITUAN_APP:
            return trimmedUrl.startsWith('imeituan://');
        case Source.DIANPING_APP:
            return trimmedUrl.startsWith('dianping://');
        case Source.WECHAT_HOTEL_MINI:
            return trimmedUrl.startsWith('/pages/');
        case Source.WECHAT_MEITUAN_MINI:
            return trimmedUrl.startsWith('/hotel/pages/');
        // case Source.WECHAT_DIANPING_MINI:
        //   return trimmedUrl.startsWith('/packages/pages/');
        default:
            // 未知平台，返回false
            return false;
    }
};
export function formatDateToTimestamp(dateString) {
    const parts = dateString.split("/");
    const [year, month, day, hour, minute, second] = parts.map(part => parseInt(part, 10));
    // 创建一个 Date 对象，注意月份需要减去 1，因为 JavaScript 中的月份是从 0 开始的
    const date = new Date(year, month - 1, day, hour, minute, second);
    return date.getTime();
}
